
const defaultAttrs = {"width":"1024","height":"1024","version":"1.1","viewBox":"0 0 1024 1024"};
const svgInner = "<path fill=\"currentColor\" d=\"M512 42.675c259.205 0 469.332 210.128 469.332 469.333S771.205 981.343 512 981.343c-259.207 0-469.334-210.13-469.334-469.335S252.794 42.675 512 42.675M409.587 346.294c-4.255 5.686-4.255 15.867-4.255 36.232v258.957c0 20.365 0 30.548 4.255 36.232a21.33 21.33 0 0 0 15.56 8.494c7.081.507 15.647-5 32.776-16.013l201.413-129.48c14.863-9.554 22.298-14.333 24.863-20.408a21.33 21.33 0 0 0 0-16.607c-2.565-6.075-9.999-10.852-24.863-20.408l-201.413-129.48c-17.129-11.011-25.695-16.517-32.776-16.013a21.34 21.34 0 0 0-15.56 8.494\"/>";

export default function PlayCircleSvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
